<div class="section-wrapper" [ngClass]="{'p-0': data.title}">
  <ng-container *ngIf="data.title">
    <h5 class="slim-card-title mb-2">{{ data.title}}</h5>
    <p class="mb-0" *ngIf="data.msg">{{data.msg}}</p>
    <hr class="my-1">
  </ng-container>
  <form [formGroup]="group">
    <div class="form-layout" [ngClass]="{'contain': data.title}">
      <ng-container *ngIf="!isProfile">
        <div class="row">
          <div class="col-lg-3">
            <mat-form-field [appearance]="appearance">
              <mat-label>Contact Level
                <app-required></app-required>
              </mat-label>
              <mat-select [formControl]="level">
                <mat-option>Select Level</mat-option>
                <mat-option *ngFor="let item of accessOptions" [value]="item.access" [disabled]="item.disable">
                  {{item.access}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="level.hasError('required')"> Please select an Option</mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-3"
            *ngIf="level.value === 'STATE' || level.value === 'DISTRICT' || level.value === 'ULB' || level.value === 'ZONE' || level.value  === 'WARD'|| level.value === 'AREA'">
            <mat-form-field [appearance]="appearance">
              <mat-label>State
                <app-required *ngIf="util.isRequired(state)"></app-required>
              </mat-label>
              <mat-select [formControl]="state">
                <mat-option>Select State</mat-option>
                <mat-option *ngFor="let item of stateOptions" [value]="item.code">
                  {{item.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="state.hasError('required')">Please select an Option</mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-3"
            *ngIf="level.value === 'DISTRICT' || level.value === 'ULB' || level.value === 'ZONE' || level.value  === 'WARD'|| level.value === 'AREA'">
            <mat-form-field [appearance]="appearance">
              <mat-label>District
                <app-required *ngIf="util.isRequired(district)"></app-required>
              </mat-label>
              <mat-select [formControl]="district">
                <mat-option>Select District</mat-option>
                <mat-option *ngFor="let item of districtOptions" [value]="item.code">
                  {{item.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="district.hasError('required')">Please select an Option</mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-3"
            *ngIf="level.value === 'ULB' || level.value === 'ZONE' || level.value  === 'WARD'|| level.value === 'AREA'">
            <mat-form-field [appearance]="appearance">
              <mat-label>City/ULB
                <app-required *ngIf="util.isRequired(ulb)"></app-required>
              </mat-label>
              <mat-select [formControl]="ulb">
                <mat-option>Select City</mat-option>
                <mat-option *ngFor="let item of ulbOptions" [value]="item.code">
                  {{item.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ulb.hasError('required')">Please select an Option</mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-3" *ngIf="level.value === 'ZONE' || level.value  === 'WARD'|| level.value === 'AREA'">
            <mat-form-field [appearance]="appearance">
              <mat-label>Zone </mat-label>
              <mat-select [formControl]="zone">
                <mat-option>Select Zone</mat-option>
                <mat-option *ngFor="let item of zoneOptions" [value]="item.id">
                  {{item.zoneName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-lg-3" *ngIf="level.value  === 'WARD'|| level.value === 'AREA'">
            <mat-form-field [appearance]="appearance">
              <mat-label>Ward
                <app-required *ngIf="util.isRequired(ward)"></app-required>
              </mat-label>
              <mat-select [formControl]="ward">
                <mat-option>Select Ward</mat-option>
                <mat-option *ngFor="let item of wardOptions" [value]="item.id">
                  {{item.wardNumber}} ({{item.wardName}})
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ward.hasError('required')">Please select an Option</mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-3" *ngIf="level.value === 'AREA'">
            <mat-form-field [appearance]="appearance">
              <mat-label>Area
                <app-required *ngIf="util.isRequired(area)"></app-required>
              </mat-label>
              <mat-select [formControl]="area" multiple>
                <mat-option *ngFor="let item of areaOptions" [value]="item.id">
                  {{item.areaName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <hr>
      </ng-container>
      <div class="row">
        <div class="col-lg-3" *ngIf="!isProfile">
          <mat-form-field [appearance]="appearance">
            <mat-label>Designation
              <app-required></app-required>
            </mat-label>
            <mat-select [formControl]="designation">
              <mat-option>Select Designation</mat-option>
              <mat-option *ngFor="let item of designationOptions" [value]="item.designationId">
                {{item.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="designation.hasError('required')"> Designation is Required</mat-error>
          </mat-form-field>
        </div>
        <app-input-field [ngClass]="getDynamicClass()" label="Name" [control]="name"> </app-input-field>
        <app-input-field [ngClass]="getDynamicClass()" label="Official Mobile" hint="It will be used for OTP"
          [control]="officialMobile" maxlength="10" restrictedTo="numberOnly"> </app-input-field>
        <app-input-field [ngClass]="getDynamicClass()" label="Official Email" hint="It will be used for OTP"
          [control]="officialEmail">
        </app-input-field>

        <ng-container *ngIf="!isProfile">
          <app-input-field class="col-lg-3" label="Official Landline" [control]="officialLandline"
            placeholder="Enter Landline No."> </app-input-field>
          <app-input-field class="col-lg-3" label="WhatsApp Number" [control]="whatsApp"
            placeholder="Enter WhatsApp No." maxlength="10"> </app-input-field>
          <app-input-field class="col-lg-3" label="Personal Email" [control]="personalEmail"
            placeholder="Enter Personal Email Id" hint="Not shown on public portal.">
          </app-input-field>
          <app-input-field class="col-lg-3" label="Personal Phone" [control]="personalMobile" maxlength="10"
            restrictedTo="numberOnly" placeholder="Enter Mobile Number" hint="Not shown on public portal.">
          </app-input-field>
          <app-input-field class="col-lg-12" label="Address" [control]="address" placeholder="Enter your Address">
          </app-input-field>
        </ng-container>
      </div>
      <div class="row" *ngIf="!isProfile">
        <app-input-field class="col-lg-3" label="Twitter" [control]="twitter"> </app-input-field>
        <app-input-field class="col-lg-3" label="Facebook" [control]="facebook"> </app-input-field>
        <app-input-field class="col-lg-3" label="Instagram" [control]="instagram"> </app-input-field>
        <app-input-field class="col-lg-3" label="Linked In" [control]="linkedin"> </app-input-field>
      </div>
      <div class="row" *ngIf="!isProfile">
        <app-file-input class="col-lg-4" [isEditable]="true" [control]="group.get('photo')" service="city"
          [isEditable]="isEditable">
        </app-file-input>
        <div class="col-lg-12">
          <mat-form-field [appearance]="appearance">
            <mat-label>Message</mat-label>
            <textarea matInput rows="4" [formControl]="message"></textarea>
          </mat-form-field>
        </div>
      </div>
    </div>
    <hr>
    <div class="form-layout-footer">
      <button *ngIf="!isEditable && editAccess && id" class="btn btn-primary" type="button"
        (click)="editForm()">Edit</button>
      <button *ngIf="isEditable" class="btn btn-primary" (click)="submit()">{{id? 'Update': 'Save'}}</button>
      <button class="btn btn-secondary" *ngIf="!isProfile" (click)="back()">Cancel</button>
    </div>
  </form>
</div>
